import type {
  CoinId,
  HistoryDays,
  HistoryResponse,
  MarketsResponse,
  OverviewResponse,
} from "./types";

async function getJson<T>(url: string): Promise<T> {
  const response = await fetch(url, {
    headers: { Accept: "application/json" },
  });
  const body = (await response.json()) as T & { message?: string };
  if (!response.ok) {
    const error = new Error(
      response.status === 401
        ? "Bitte erneut anmelden."
        : response.status === 429
          ? "Kursdienst-Limit erreicht. Bitte kurz warten."
          : "Krypto-Daten konnten nicht geladen werden.",
    ) as Error & { status?: number };
    error.status = response.status;
    throw error;
  }
  return body;
}

export function loadOverview(): Promise<OverviewResponse> {
  return getJson<OverviewResponse>("/api/crypto/overview");
}

export function loadMarkets(): Promise<MarketsResponse> {
  return getJson<MarketsResponse>("/api/crypto/markets");
}

export function loadHistory(id: CoinId, days: HistoryDays): Promise<HistoryResponse> {
  return getJson<HistoryResponse>(`/api/crypto/${id}/history?days=${days}`);
}

export function formatMoney(value: number): string {
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: value < 1 ? 4 : 2,
    maximumFractionDigits: value < 1 ? 4 : 2,
  }).format(value);
}

export function formatCompact(value: number): string {
  return new Intl.NumberFormat("de-DE", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(value);
}

export function formatDate(timestamp: number): string {
  return new Date(timestamp * 1000).toLocaleString("de-DE");
}

export function marketIsStale(timestamp: number): boolean {
  return Date.now() - timestamp * 1000 > 5 * 60 * 1000;
}
